import { VictoryPie } from 'victory';

import { motion } from 'framer-motion';
import { Card } from './styles';

import NoData from '../../../../../components/NoData';
import { UserProfileType } from '../../types';

interface UserProfileCardInterface {
  dashboardUserProfileData: UserProfileType;
  selectedWorkplace: { value: number, label: string };
}

export default function UserProfileCard({ dashboardUserProfileData, selectedWorkplace }: UserProfileCardInterface) {
  return (
    <Card>
      <div className="card-title">
        <div>Perfil usuário</div>
      </div>

      {dashboardUserProfileData && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 1.2, type: 'tween', stiffness: 10000 }}
            className="card-main-graph"
          >
            <VictoryPie
              data={[
                {
                  x: 1,
                  y: dashboardUserProfileData.totFuncTitular,
                  label: `Titulares: ${dashboardUserProfileData.totFuncTitular} %`,
                },
                {
                  x: 2,
                  y: dashboardUserProfileData.totFuncAvulso,
                  label: `Avulsos: ${dashboardUserProfileData.totFuncAvulso} %`,
                },
                {
                  x: 3,
                  y: dashboardUserProfileData.totFuncOutros,
                  label: `Livres: ${dashboardUserProfileData.totFuncOutros} %`,
                },
              ]}
              animate={{
                duration: 2000,
                onLoad: { duration: 5000 },
              }}
              colorScale={['#8b9a71', '#ff6361', '#ffa600']}
              innerRadius={80}
              height={187}
              padAngle={0}
              padding={0}
            />
          </motion.div>
          <div className="legend">
            <small className="titulares">
            ● Titulares:
              {' '}
              {dashboardUserProfileData.totFuncTitular}
            %
            </small>
            <small className="avulsos">
            ● Avulsos:
              {' '}
              {dashboardUserProfileData.totFuncAvulso}
            %
            </small>
            <small className="outros">
            ● Outros:
              {' '}
              {dashboardUserProfileData.totFuncOutros}
            %
            </small>
          </div>
        </>
      )}

      {(!dashboardUserProfileData) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
            O local de trabalho
              {' '}
              <strong>{selectedWorkplace.label}</strong>
              {' '}
            não possui dados sobre o perfil dos usuários.
            </>
          )}
        />
      )}
    </Card>
  );
}
